import { render, staticRenderFns } from "./ChooseVertical.vue?vue&type=template&id=55a2e2a0"
import script from "./ChooseVertical.vue?vue&type=script&lang=ts"
export * from "./ChooseVertical.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports